import {
    CHANGE_LEADS_CUSTOMER_REQUEST,
    CHANGE_LEADS_CUSTOMER_REQUEST_SUCCESS,
    CHANGE_LEADS_CUSTOMER_REQUEST_FAILURE,
    UPDATE_LEAD_CUSTOMER_DATE_REQUEST,
} from '../constants/get_lead_profile.constants';

export const changeLeadCustomerRequest = (_id, key, value) => ({
    type: CHANGE_LEADS_CUSTOMER_REQUEST, _id, key, value,
});
export const changeLeadCustomerRequestSuccess = (payload) => ({ type: CHANGE_LEADS_CUSTOMER_REQUEST_SUCCESS, payload });
export const changeLeadCustomerRequestFailure = (error) => ({ type: CHANGE_LEADS_CUSTOMER_REQUEST_FAILURE, error });

export const updateLeadCustomerDateRequest = (_id, customer_collection_date) => ({
    type: UPDATE_LEAD_CUSTOMER_DATE_REQUEST, _id, customer_collection_date,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/change_lead_customer.actions.js